import React, {FC} from 'react';
import claimedCoinsExplosion from '../../../assets/desktop-coins-explosion.riv';
import {CoinsExplosionAnimation} from './CoinsExplosionAnimation';

export const CoinsExplosionAnimationRectangular: FC<{
  showBodyContent: boolean;
}> = ({showBodyContent}) => (
  <CoinsExplosionAnimation
    showBodyContent={showBodyContent}
    riveSrc={claimedCoinsExplosion}
  />
);
